import React from "react";
import "react-table-v6/react-table.css";
import {
  Icon,
  Button,
  Modal,
  Dropdown,
  Label,
  Divider,
  Dimmer,
  Loader,
  Form,
  Grid,
  Input
} from "semantic-ui-react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Box from '@mui/material/Box';
import { fetchMasterData,filterMasterData,distributorFileUpload,saveUploadedMasterfile,
  sendFeedbackMail,deleteFileFromDistributorSide,userForceLogout,distributorSupportingFileUpload,
  summaryRemarksUpload,downloadSelectedFiles,startBulkDownloadJob,pollBulkDownloadStatus,
  rollbackPairMasterUpload
} from "../../actions/users_action";
import { DataGrid, GridToolbarContainer, GridToolbarFilterButton, GridToolbarDensitySelector } from "@mui/x-data-grid";
import config from "../../config.js";
import ButtonHandler from "../ButtonHandler.jsx";
import { debounce } from 'lodash';

const storageBaseUrl = config["storage_base_url"];

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
    </GridToolbarContainer>
  );
}

var apiTimeout = null;
const SELLER_MASTER_FILE_NAME = "Seller Master";
const STORE_MASTER_FILE_NAME = "Store Master";

class MainView extends React.Component {
  
  constructor(props) {
    
    super(props);
    
    this.state = {
      auditsList: [],
      mainView: true,
      selectDistributor:'',
      selectMonth:'',
      selection: [],
      pageSize: 15,
      templates:[],
      distributors:[],
      fileList:[],
      modalOpen:false,
      fileName:'',
      currentFile:'',
      id:'',
      remarks:'',
      saveData:{},
      mailModal:false,
      message : '',
      showDeleteConfirmModal:false,
      selectedFileName:'',
      supportingFileName:'',
      supportingModalOpen:false,
      supportingId:'',
      supportingRemarks:'',
      isChecked:false,
      loaderStatus:false,
      selectedFiles: [],
      selectAllChecked: false,
      bulkDownloadJobId: null,
      bulkDownloadStatus: null,  // null | 'pending' | 'processing' | 'done' | 'failed'
      pairUploadFlowActive: false,
      pairFirstFileName: "",
      pairSecondFileName: "",
      pairAwaitingSecond: false,
      pairFirstFileSaved: false,
    };
    this.updateRemarks = debounce(this.updateRemarks, 1000);
  }

  isPairRequiredFile = (fileName) => {
    return fileName === SELLER_MASTER_FILE_NAME || fileName === STORE_MASTER_FILE_NAME;
  }

  getPairFileName = (fileName) => {
    if (fileName === SELLER_MASTER_FILE_NAME) {
      return STORE_MASTER_FILE_NAME;
    }
    if (fileName === STORE_MASTER_FILE_NAME) {
      return SELLER_MASTER_FILE_NAME;
    }
    return "";
  }

  isPairCounterpartSuccessful = (fileName, fileList = this.state.fileList) => {
    if (!this.isPairRequiredFile(fileName)) {
      return false;
    }

    const counterpartFileName = this.getPairFileName(fileName);
    const counterpart = (fileList || []).find((f) => f.fileName === counterpartFileName);
    return Boolean(counterpart && counterpart.fileUploadStatus === 'Success');
  }

  resetPairUploadState = () => {
    this.setState({
      pairUploadFlowActive: false,
      pairFirstFileName: "",
      pairSecondFileName: "",
      pairAwaitingSecond: false,
      pairFirstFileSaved: false,
    });
  }

  rollbackFirstPairUpload = (alertMessage = "Both Seller Master and Store Master files are required.") => {
    const rollbackData = {
      templateName: this.state.selectMonth,
      distributor: this.state.selectDistributor,
      fileName: this.state.pairFirstFileName,
    };

    this.props.rollbackPairMasterUpload(rollbackData, {
      onSuccess: () => {
        const data = {
          templateMonth: this.state.selectMonth,
          distributor: this.state.selectDistributor,
        };
        this.props.filterMasterData(data, {
          onSuccess: (res) => {
            this.setState({
              fileList: this.normalizeFileList(res.files),
              modalOpen: false,
              mailModal: false,
              supportingModalOpen: false,
              currentFile: '',
              loading: false,
            });
            this.resetPairUploadState();
            alert(alertMessage);
          },
          onFailure: () => {
            this.setState({ modalOpen: false, loading: false, currentFile: '' });
            this.resetPairUploadState();
            alert(alertMessage);
          }
        });
      },
      onFailure: () => {
        this.setState({ modalOpen: false, loading: false, currentFile: '' });
        this.resetPairUploadState();
        alert(alertMessage);
      }
    });
  }
  
  componentDidMount() {
    // console.log(this.props.auth.loginId,'userIdddd')
      this.props.userForceLogout(this.props.auth.loginId,{
        onSuccess:(res)=>{
            // console.log(res.userLog,'userlog')
            if(res.userLog == true){
              this.props.history.push(`/login`);
            }
        },
        onFailure:()=>{

        }
      })
      this.props.fetchMasterData({
        onSuccess:(res)=>{
            this.setState({'templates':res.templates,'distributors':res.distributors})
        },
        onFailure:()=>{

        }
      })
  }

  normalizeFileList = (files = []) => {
    return (files || []).map((file, index) => {
      if (file && file._rowKey) {
        return file;
      }
      return {
        ...file,
        _rowKey: `${index}-${String((file && file.fileName) || '').toLowerCase()}`,
      };
    });
  }

  onMonthChange = (e,data) =>{
      this.setState({selectMonth:data.value})
  }

  onDistributorChange = (e,data) =>{
      this.setState({selectDistributor:data.value})
  }

  filterMaster = () =>{
    let data = {
      templateMonth:this.state.selectMonth,
      distributor:this.state.selectDistributor
    }
    this.props.filterMasterData(data,{
      onSuccess:(res)=>{
          this.setState({'fileList':this.normalizeFileList(res.files), selectedFiles: [], selectAllChecked: false})
      },
      onFailure:()=>{

      }
    })
  }

  downloadFile = (url) => {
    window.open(url);
}

downloadSupportingFiles = (files) =>{
  files.forEach(file => {
    window.open(file.fileUrl, '_blank');
});
}

downloadHistoryFiles = (files) =>{
  files.forEach(file => {
    window.open(file, '_blank');
});
}

fileupload = (file) => {
  // console.log(file.target.files,'fileeee')
  this.setState({ currentFile: file.target.files[0] })
};

supportingFileupload = (file)=>{
  const files = file.target.files;
  const maxSizeInMB = 20;
  const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
  let totalSize = 0;
  for (let i = 0; i < files.length; i++) {
      totalSize += files[i].size;
  }

  if (totalSize > maxSizeInBytes) {
      alert(`Total file size exceeds the 20MB limit.`);
      this.setState({currentFile:'',supportingModalOpen:false})
      return;
  }
  else{
    // console.log(file.target.files,'fileeeeee')
      const filesArray = Array.from(file.target.files);
     this.setState({currentFile:filesArray})
  }
}


uploadFile = (fileName,id,remarks,rowData) => {
  console.log(rowData,'rowData')
  console.log(this.state.fileList,'fileList')
  const targetFile = rowData || (this.state.fileList || []).find((f) => f.fileName === fileName);
  if (targetFile && targetFile.one_time_locked) {
    alert("One time upload enabled, contact admin.");
    return;
  }
  // if(fileName == 'Hotspot Smartspot Target'){
  //   this.state.fileList.map((d)=>{
  //     if(d.fileName == 'Hotspot Smartspot Execution'){
  //         if(!d.fileUploadStatus){
  //           alert("Please Upload Hotspot Smartspot Execution File First.")
  //         }
  //         else{
  //           this.setState({ fileName: fileName, modalOpen: true,id:id,remarks:remarks })
  //         }
  //     }
  //   })
  // }
  // else{
    if (
      this.state.pairUploadFlowActive
      && this.state.pairAwaitingSecond
      && fileName !== this.state.pairSecondFileName
    ) {
      alert(`Pair upload pending: please upload ${this.state.pairSecondFileName} first.`);
      const nextFile = this.state.fileList.find((f) => f.fileName === this.state.pairSecondFileName);
      if (nextFile) {
        this.setState({
          fileName: nextFile.fileName,
          id: nextFile.id,
          remarks: nextFile.remarks,
          modalOpen: true,
          currentFile: ''
        });
      }
      return;
    }

    if (this.isPairRequiredFile(fileName)) {
      this.setState({
        pairUploadFlowActive: true,
        pairFirstFileName: fileName,
        pairSecondFileName: this.getPairFileName(fileName),
        pairAwaitingSecond: false,
        pairFirstFileSaved: false,
      });
    } else {
      this.resetPairUploadState();
    }

    this.setState({ fileName: fileName, modalOpen: true,id:id,remarks:remarks,currentFile:'' })
  // }
  
}

uploadSupportingFile = (fileName,id,remarks)=>{
  this.setState({ supportingFileName: fileName, supportingModalOpen: true,supportingId:id,supportingRemarks:remarks })
}

closeuploadoption = () => {
  if (this.state.modalOpen && this.state.pairUploadFlowActive && this.state.pairAwaitingSecond) {
    this.rollbackFirstPairUpload();
    return;
  }

  this.setState({ modalOpen: false,mailModal:false,supportingModalOpen:false,currentFile:'' })

  if (this.state.pairUploadFlowActive && !this.state.pairFirstFileSaved) {
    this.resetPairUploadState();
  }
}

loadData  = async()=> {
  try {
    let data = {
                templateMonth:this.state.selectMonth,
                distributor:this.state.selectDistributor
              }
    
    await this.props.filterMasterData(data,{
                    onSuccess:(res)=>{
                        const normalizedFiles = this.normalizeFileList(res.files);
                        const currentUpload = normalizedFiles.find((d) => d.fileName == this.state.fileName)
                        if (!currentUpload) {
                          apiTimeout = setTimeout(this.loadData, 1000);
                          this.setState({'fileList':normalizedFiles,modalOpen: false,loading:false})
                          return;
                        }

                        if(currentUpload.fileUploadStatus == 'Success'){
                          clearTimeout(apiTimeout);
                          let fileData = this.state.saveData;
                          const uploadedFileName = this.state.fileName;

                          this.props.saveUploadedMasterfile(fileData, {
                            onSuccess: () => {
                              this.props.filterMasterData(data,{
                                onSuccess:(refreshRes)=>{
                                  const refreshedFiles = this.normalizeFileList(refreshRes.files || []);
                                  const firstLegCompleted = this.state.pairUploadFlowActive
                                    && this.state.pairAwaitingSecond === false
                                    && uploadedFileName === this.state.pairFirstFileName;
                                  const secondLegCompleted = this.state.pairUploadFlowActive
                                    && this.state.pairAwaitingSecond === true
                                    && uploadedFileName === this.state.pairSecondFileName;

                                  if (firstLegCompleted) {
                                    const nextFile = refreshedFiles.find(
                                      (f) => f.fileName === this.state.pairSecondFileName
                                    );

                                    if (nextFile) {
                                      alert(`Please upload ${this.state.pairSecondFileName} file to continue.`);
                                      this.setState({
                                        fileList: refreshedFiles,
                                        fileName: nextFile.fileName,
                                        id: nextFile.id,
                                        remarks: nextFile.remarks,
                                        currentFile: '',
                                        modalOpen: true,
                                        loading: false,
                                        pairAwaitingSecond: true,
                                        pairFirstFileSaved: true,
                                      });
                                      return;
                                    }

                                    this.setState({ fileList: refreshedFiles, modalOpen: false, loading: false });
                                    this.rollbackFirstPairUpload();
                                    return;
                                  }

                                  if (secondLegCompleted) {
                                    this.setState({
                                      fileList: refreshedFiles,
                                      modalOpen: false,
                                      loading: false,
                                      currentFile: '',
                                    });
                                    this.resetPairUploadState();
                                    alert("Seller Master and Store Master files are uploaded successfully.");
                                    return;
                                  }

                                  this.setState({'fileList':refreshedFiles,modalOpen: false,loading:false,currentFile:''})
                                },
                                onFailure:()=>{

                                }
                              })
                            },
                            onFailure: () => {
                            }
                        })
                        }
                        else if(currentUpload.fileUploadStatus == 'Failed'){
                          clearTimeout(apiTimeout);
                          if (
                            this.state.pairUploadFlowActive
                            && this.state.pairAwaitingSecond === true
                            && currentUpload.fileName === this.state.pairSecondFileName
                          ) {
                            this.rollbackFirstPairUpload(
                              `${this.state.pairSecondFileName} upload failed. First uploaded file has been removed. Please download Failed Docs, fix the file, and upload both files again.`
                            );
                            return;
                          }

                          this.props.filterMasterData(data,{
                            onSuccess:(refreshRes)=>{
                                this.setState({'fileList':this.normalizeFileList(refreshRes.files)})
                            },
                            onFailure:()=>{

                            }
                          })
                          if (this.state.pairUploadFlowActive && this.state.pairAwaitingSecond === false) {
                            this.resetPairUploadState();
                          }
                        }
                        else{
                          apiTimeout = setTimeout(this.loadData, 1000);
                          this.setState({'fileList':normalizedFiles,modalOpen: false,loading:false})
                        }

                    },
                    onFailure:()=>{
                      clearTimeout(apiTimeout);
                    }
                  })
 
 } catch (e) {
     console.log(e);
 }
}


uploadTemplate = () => {
  if (!this.state.currentFile || this.state.currentFile.length === 0) {
    alert("Please choose a file before uploading.");
    return;
  }

  this.setState({loading:true})
  console.log(this.state.selectDistributor,'selectedDist')
  this.props.distributorFileUpload(this.state.currentFile, this.state.fileName,this.state.selectMonth,this.state.selectDistributor,
      {
          onSuccess: (res) => {
                let fileData = {
                  fileName: this.state.fileName,
                  fileUrl: res.fileUrl,
                  templateName:this.state.selectMonth,
                  distributor:this.state.selectDistributor,
                  id:this.state.id,
                  remarks:this.state.remarks
              }
              this.setState({saveData:fileData,loading:false,modalOpen:false})
              apiTimeout = setTimeout(this.loadData, 1000);      
          },
          onFailure: (error) => {
              const message =
                (error && error.response && error.response.data && error.response.data.message)
                || (error && error.response && error.response.data && error.response.data.error)
                || "Upload cancelled.";
              this.setState({ loading: false, modalOpen: false, currentFile: '' });
              alert(message);
          }
      }
  )
}

uploadSupportingDocs = () =>{
  this.setState({loading:true})
  this.props.distributorSupportingFileUpload(this.state.currentFile, this.state.supportingFileName,this.state.selectMonth,this.state.selectDistributor,
    {
        onSuccess: (res) => {
          this.setState({loading:false,supportingModalOpen:false})
          apiTimeout = setTimeout(this.loadData, 1000); 
          alert("Attachments Uploaded Successfully. Click Filter again to see count of uploaded files")     
        },
        onFailure: () => {

        }
    }
)

}

deleteFile = (fileName) => {
    this.setState({showDeleteConfirmModal:true,selectedFileName:fileName})
}

closeCandidateDeleteModal = ()=>{
  this.setState({showDeleteConfirmModal:false})
}

  deleteTemplateMaster = () =>{
    let data = {
      fileName:this.state.selectedFileName,
      distributorName:this.state.selectDistributor
    }
    this.props.deleteFileFromDistributorSide(data,{
      onSuccess:()=>{
        this.setState({showDeleteConfirmModal:false})
        let data = {
          templateMonth:this.state.selectMonth,
          distributor:this.state.selectDistributor
        }
        this.props.filterMasterData(data,{
          onSuccess:(res)=>{
              this.setState({'fileList':this.normalizeFileList(res.files)})
          },
          onFailure:()=>{
    
          }
        })
      },
      onFailure:()=>{

      }
    })
  }

  sendMail = () =>{
    this.setState({mailModal:true})
  }

  message = (e) =>{
    this.setState({message:e.target.value})
  }

  mailTrigger = () =>{
    this.setState({loaderStatus:true})
    let feedback = {
      message:this.state.message,
      siteName:this.state.selectDistributor
    }
    
    this.props.sendFeedbackMail(feedback,{
      onSuccess:()=>{
        this.setState({mailModal:false,loaderStatus:false})
      },
      onFailure:()=>{

      }
    })
  }

  handleRemarksChange = (e,row) =>{
    const { value } = e.target; 
    const fileNameToUpdate = row.row.fileName;

    const updatedFileList = this.state.fileList.map(file => {
      if (file.fileName === fileNameToUpdate) {
        return { ...file, disRemarks: value }; 
      }
      return file;
    });
    this.setState({ fileList: updatedFileList });

    this.updateRemarks();
  }

  updateRemarks = () =>{
    const filteredItems = this.state.fileList.filter(item => !item.fieldsConditions);
    let data = {
      templateName:this.state.selectMonth,
      fileTemplates:filteredItems
    }
    this.props.summaryRemarksUpload(data,{
      onSuccess:()=>{

      },
      onFailure:()=>{

      }
    })
  }

  handleFileSelection = (fileId) => {
    const selectedFiles = this.state.selectedFiles.includes(fileId)
      ? this.state.selectedFiles.filter(id => id !== fileId)
      : [...this.state.selectedFiles, fileId];
    
    const allSelected = selectedFiles.length === this.state.fileList.length;
    this.setState({ selectedFiles, selectAllChecked: allSelected });
  }

  handleSelectAll = (checked) => {
    const selectedFiles = checked ? this.state.fileList.map((file, index) => index) : [];
    this.setState({ selectedFiles, selectAllChecked: checked });
  }

  downloadSelectedFilesHandler = () => {
    if (this.state.selectedFiles.length === 0) {
      alert('Please select at least one file to download');
      return;
    }

    const filesToDownload = this.state.selectedFiles.map(index => {
      const file = this.state.fileList[index];
      return {
        fileName: file.remarks || file.fileName,
        fileUrl: file.fileUrl
      };
    });

    this.props.downloadSelectedFiles(filesToDownload, this.state.selectDistributor, {
      onSuccess: () => {
        alert('Files downloaded successfully');
        this.setState({ selectedFiles: [], selectAllChecked: false });
      },
      onFailure: (error) => {
        alert('Failed to download files: ' + (error.message || 'Unknown error'));
      }
    });
  }

  downloadAllDistributorsZipHandler = () => {
    if (!this.state.selectMonth) {
      alert('Please select a month first');
      return;
    }

    this.setState({ bulkDownloadStatus: 'pending' });

    this.props.startBulkDownloadJob(this.state.selectMonth, {
      onSuccess: (data) => {
        this.setState({ bulkDownloadJobId: data.jobId, bulkDownloadStatus: 'pending' });
        this._pollBulkDownload(data.jobId);
      },
      onFailure: () => {
        this.setState({ bulkDownloadStatus: null });
        alert('Failed to start download job. Please try again.');
      }
    });
  }

  _pollBulkDownload = (jobId) => {
    this.props.pollBulkDownloadStatus(jobId, {
      onSuccess: (data) => {
        this.setState({ bulkDownloadStatus: data.status });

        if (data.status === 'done') {
          // Trigger browser download via hidden anchor
          const link = document.createElement('a');
          link.href = data.downloadUrl;
          link.setAttribute('download', `${this.state.selectMonth}_AllDistributors.zip`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.setState({ bulkDownloadJobId: null, bulkDownloadStatus: null });
        } else if (data.status === 'failed') {
          alert('Bulk download failed: ' + (data.error || 'Unknown error'));
          this.setState({ bulkDownloadJobId: null, bulkDownloadStatus: null });
        } else {
          // Still pending/processing — poll again in 4 seconds
          setTimeout(() => this._pollBulkDownload(jobId), 4000);
        }
      },
      onFailure: () => {
        // Network hiccup — retry polling
        setTimeout(() => this._pollBulkDownload(jobId), 5000);
      }
    });
  }

  handleCheckboxChange = (e,row)=>{
    const fileNameToUpdate = row.row.fileName;
    const updatedFileList = this.state.fileList.map(file => {
      if (file.fileName === fileNameToUpdate) {
        if(e.target.checked == false){
          delete file.fieldsConditions
          delete file.requiredCol
          return { ...file, isChecked: e.target.checked,templateEnabled:e.target.checked,fileUploadStatus:'Not Applicable' }; 
        }
        else{

        return { ...file, isChecked: e.target.checked,templateEnabled:e.target.checked,fieldsConditions:[],fileUploadStatus:''}; 
        }

      }
      return file;
    });
    this.setState({ fileList: updatedFileList });
    this.updateRemarks();
  }

   formatDate = (dateValue) => {
    if (!dateValue) return '';
    
    try {
      // Check if the date is in ISO format
      if (dateValue.includes('T')) {
        const [date, time] = dateValue.split('T');
        const formattedTime = time.split('.')[0];
        return `${date} ${formattedTime}`;
      }
      
      // Handle string format
      if (dateValue.includes(' ')) {
        const [date, timeWithMs] = dateValue.split(' ');
        const time = timeWithMs.split('.')[0];
        return `${date} ${time}`;
      }
      
      return dateValue;
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  };
  
   DateFormatCell = ({ value }) => (
    <strong>{formatDate(value)}</strong>
  );


  render() {
    var monthsList = []
    var distributorList = []

    this.state.templates.map((d)=>{
      monthsList.push({
        'key':d.name,
        'value':d.name,
        'text':d.name
      })
    })

    this.state.distributors.map((d)=>{
      if(d.siteName){
        distributorList.push({
          'key':d.siteName + '-' + d.location,
          'value':d.siteName + '-' + d.location,
          'text':d.siteName + '-' + d.location
        })
      }
      
      
    })

    if(this.props.auth.role == 'admin'){
      distributorList.push({
        'key':'All Distributors',
        'value': 'All Distributors',
        'text': 'All Distributors'
      })
    }

    let otherCol = [
      {
        headerName: <p style={{color:'white'}}><strong>{"File Name"}</strong></p>,
        headerClassName: 'super-app-theme--header',
        field: "fileName",
        style: { textAlign: "center", cursor: "pointer",fontWeight:'bold' },
        width: 600,
        renderCell: (row) => (
          <AuditTableCell
            row={row.row}
            text={<strong>{row.row.fileName}</strong>}
          />
        ),
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"Download"}</strong></p>,
        field: "report",
        headerClassName: 'super-app-theme--header',
        style: { textAlign: "center", cursor: "pointer" },
        sortable: false,
        width: 550,
        filterable: false,
        renderCell: (row) => {
          return (
            <div style={{cursor:'pointer'}}>
               <Icon
              size="large"
              color="red"
              name="download"
              onClick={() =>this.downloadFile(row.row.fileUrl)}
              
            />
            </div>
           
          );
        },
      },
    ]

    let AdminColumnsDataGrid = [
      {
        headerName: <p style={{color:'white'}}><strong>{"Select"}</strong></p>,
        field: "select",
        headerClassName: 'super-app-theme--header',
        width: 80,
        sortable: false,
        filterable: false,
        renderCell: (row) => (
          <input
            type="checkbox"
            checked={this.state.selectedFiles.includes(this.state.fileList.indexOf(row.row))}
            onChange={() => this.handleFileSelection(this.state.fileList.indexOf(row.row))}
          />
        ),
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"File Name"}</strong></p>,
        headerClassName: 'super-app-theme--header',
        field: "remarks",
        style: { textAlign: "center", cursor: "pointer",fontWeight:'bold' },
        width: 200,
        renderCell: (row) => (
          <AuditTableCell
            row={row.row}
            text={<strong>{row.row.remarks}</strong>}
          />
        ),
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"File Uploaded Date"}</strong></p>,
        field: "createdAt",
        headerClassName: 'super-app-theme--header',
        width: 200,
        style: { textAlign: "center", cursor: "pointer" },
        renderCell: (row) => (
          <AuditTableCell
            row={row.row}
            text={<strong>{this.formatDate(row.row.distributotUploadDate)}</strong>}
          />
        ),
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"Download"}</strong></p>,
        field: "report",
        headerClassName: 'super-app-theme--header',
        style: { textAlign: "center", cursor: "pointer" },
        sortable: false,
        width: 100,
        filterable: false,
        renderCell: (row) => {
          return (
            <div style={{cursor:'pointer'}}>
               <Icon
              size="large"
              color="red"
              name="download"
              onClick={() =>this.downloadFile(row.row.fileUrl)}
              
            />
            </div>
           
          );
        },
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"Upload"}</strong></p>,
        field: "distfileUpload",
        headerClassName: 'super-app-theme--header',
        style: { textAlign: "center" },
        width: 100,
        sortable: false,
        filterable: false,
        renderCell: (row) => (
          <div style={{cursor:'pointer'}}>
               <Icon
               size="large"
               color="blue"
               name= {"upload"}
               onClick={() => this.uploadFile(row.row.fileName,row.row.id,row.row.remarks,row.row)}
              //  disabled={row.row.clusterStatus == true ? false : true}
             />
      
              
          </div>
        ),
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"Delete"}</strong></p>,
        field: "viewaudit",
        headerClassName: 'super-app-theme--header',
        style: { textAlign: "center" },
        width: 100,
        sortable: false,
        filterable: false,
        renderCell: (row) => (
          <div style={{cursor:'pointer'}}>
            {/* {console.log(this.props.auth.userName,'userName')} */}
         
              <Icon
              size="large"
              color="blue"
              name= {"delete"}
              disabled={this.props.auth.userName == 'MatrixLogin'||this.props.auth.userName == 'PhotoAudit' ? true : false}
              onClick={() => this.deleteFile(row.row.fileName)}
            />
      
            
          </div>
        ),
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"File Upload Status"}</strong></p>,
        field: "fileUploadStatus",
        headerClassName: 'super-app-theme--header',
        width: 150,
        style: { textAlign: "center", cursor: "pointer" },
        renderCell: (row) => (
          <AuditTableCell
            row={row.row}
            text={<strong>{row.row.fileUploadStatus != undefined ? row.row.fileUploadStatus : ''}</strong>}
          />
        ),
      },
      
      {
        
        headerName: <p style={{color:'white'}}><strong>{"Email"}</strong></p>,
        field: "email",
        headerClassName: 'super-app-theme--header',
        style: { textAlign: "center", cursor: "pointer" },
        sortable: false,
        width: 100,
        filterable: false,
        renderCell: (row) => {
          return (
            <div style={{cursor:'pointer'}}>
               <Icon
              size="large"
              color="red"
              name="mail"
              onClick={() =>this.sendMail()}
              
            />
            </div>
           
          );
        }
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"Supporting Documents"}</strong></p>,
        field: "supportingDocs",
        headerClassName: 'super-app-theme--header',
        style: { textAlign: "center", cursor: "pointer" },
        sortable: false,
        width: 150,
        filterable: false,
        renderCell: (row) => {
          return (
            <div style={{cursor:'pointer'}}>
               <Icon
              size="large"
              color="red"
              name="download"
              disabled={row.row.supporting_doc && row.row.supporting_doc != undefined ? false :true}
              onClick={() =>this.downloadSupportingFiles(row.row.supporting_doc)}
              
            />
            </div>
           
          );
        },
      },
         {
        headerName: <p style={{color:'white'}}><strong>{"Failed Docs"}</strong></p>,
        field: "failedDocs",
        headerClassName: 'super-app-theme--header',
        style: { textAlign: "center", cursor: "pointer" },
        sortable: false,
        width: 150,
        filterable: false,
        renderCell: (row) => {
          return (
            <div style={{cursor:'pointer'}}>
               <Icon
              size="large"
              color="red"
              name="download"
              disabled={row.row.error_url && row.row.error_url != undefined ? false :true}
              onClick={() =>this.downloadFile(row.row.error_url)}
              
            />
            </div>
           
          );
        },
      },
       {
        headerName: <p style={{color:'white'}}><strong>{"Supporting Attachments"}</strong></p>,
        field: "upload",
        headerClassName: 'super-app-theme--header',
        width: 200,
        style: { textAlign: "center", cursor: "pointer" },
        renderCell: (row) => (
          <div style={{cursor:'pointer'}}>
      
            <Icon
            size="large"
            color="blue"
            name= {"upload"}
            onClick={() => this.uploadSupportingFile(row.row.fileName,row.row.id,row.row.remarks)}
            disabled={row.row.fileUploadStatus == 'Success' ? false : true}
          />
    
         </div>
        ),
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"Supporting Docs"}</strong></p>,
        field: "supportingDocsName",
        headerClassName: 'super-app-theme--header',
        style: { textAlign: "center", cursor: "pointer" },
        sortable: false,
        width: 300,
        filterable: false,
        renderCell: (row) => {
          let overall = ''
          if(row.row.supporting_doc && row.row.supporting_doc!=undefined){
            row.row.supporting_doc.forEach((file)=>{
              overall+=`${file.fileName}\n,`
            })
          }
          return (
            <AuditTableCell
            row={row.row}
            text={<strong>{overall != '' ? overall : ''}</strong>}
          />
           
          );
        },
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"Remarks"}</strong></p>,
        field: "distRemarks",
        headerClassName: 'super-app-theme--header',
        width: 270,
        style: { textAlign: "center", cursor: "pointer" },
        renderCell: (row) => {
          return (
            <textarea
            placeholder=""
            value={row.row.disRemarks != undefined ? row.row.disRemarks : ''}  // Use the state to track remarks
            rows={4}  // Number of visible rows (can adjust as needed)
            style={{ marginLeft: '10px', width: '100%',height:'50%'}}  // Allow resizing vertically
          />
           
          );
        },
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"Upload History"}</strong></p>,
        field: "historyUploaded",
        headerClassName: 'super-app-theme--header',
        style: { textAlign: "center", cursor: "pointer" },
        sortable: false,
        width: 150,
        filterable: false,
        renderCell: (row) => {
          return (
            <div style={{cursor:'pointer'}}>
               <Icon
              size="large"
              color="red"
              name="download"
              disabled={row.row.update_history && row.row.update_history != undefined ? false :true}
              onClick={() =>this.downloadHistoryFiles(row.row.update_history)}
              
            />
            </div>
           
          );
        },
      },
    ];

    let disbutorColGrid = [
      {
        headerName: <p style={{color:'white'}}><strong>{"File Name"}</strong></p>,
        headerClassName: 'super-app-theme--header',
        field: "remarks",
        style: { textAlign: "center", cursor: "pointer",fontWeight:'bold' },
        width: 200,
        renderCell: (row) => (
          
          <AuditTableCell
            row={row.row}
            text={<strong>{row.row.remarks}</strong>}
          />
        ),
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"File Uploaded Date"}</strong></p>,
        field: "createdAt",
        headerClassName: 'super-app-theme--header',
        width: 170,
        style: { textAlign: "center", cursor: "pointer" },
        renderCell: (row) => (
          <AuditTableCell
            row={row.row}
            text={<strong>{this.formatDate(row.row.distributotUploadDate)}</strong>}
          />
        ),
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"Applicable Check"}</strong></p>,
        field: "applicable",
        headerClassName: 'super-app-theme--header',
        width: 170,
        style: { textAlign: "center", cursor: "pointer" },
        renderCell: (row) => (
          <div className="ui toggle checkbox">
        <input
          type="checkbox"
          name="public"
          checked={row.row.isChecked ? row.row.isChecked : false}
          onChange={(e)=>this.handleCheckboxChange(e,row)}
          disabled={row.row.fileUploadStatus && row.row.fileUploadStatus != 'Not Applicable' ? true : false}
        />
        <label></label>
      </div>
        ),
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"Template"}</strong></p>,
        field: "template",
        headerClassName: 'super-app-theme--header',
        style: { textAlign: "center", cursor: "pointer" },
        sortable: false,
        width: 150,
        filterable: false,
        renderCell: (row) => {
          return (
            <div style={{cursor:'pointer'}}>
               <Icon
              size="large"
              color="red"
              name="download"
              // onClick={() =>this.downloadFile(storageBaseUrl+row.row.template)}
              onClick={() => this.downloadFile((row.row.template || row.row.fileUrl))}
              disabled={row.row.isChecked && row.row.isChecked == true ? false : true}
            />
            </div>
           
          );
        },
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"Download"}</strong></p>,
        field: "report",
        headerClassName: 'super-app-theme--header',
        style: { textAlign: "center", cursor: "pointer" },
        sortable: false,
        width: 150,
        filterable: false,
        renderCell: (row) => {
          return (
            <div style={{cursor:'pointer'}}>
               <Icon
              size="large"
              color="red"
              name="download"
              onClick={() =>this.downloadFile((row.row.fileUrl || row.row.template) )}
              disabled={row.row.isChecked && row.row.isChecked == true ? false : true}
            />
            </div>
           
          );
        },
      },
      {
        headerName: <p style={{color: 'white'}}><strong>{this.props.auth.role === 'admin' ? "Delete" : "Upload"}</strong></p>,
        field: "viewaudit",
        headerClassName: 'super-app-theme--header',
        style: { textAlign: "center" },
        width: 170,
        sortable: false,
        filterable: false,
        renderCell: (row) => {
            // Function to check if the current date is within the date range
            const isWithinDateRange = () => {
                const startDate = new Date(row.row.fileEnableStart + "T00:00:00");
                const endDate = new Date(row.row.fileEnableEnd + "T23:59:59");
                const currentDate = new Date(); // Get the current date
                return currentDate >= startDate && currentDate <= endDate;
            };
     
            const isLocked = Boolean(row.row && row.row.one_time_locked);
            return (
              <div style={{ cursor: isLocked ? 'not-allowed' : 'pointer' }}>
                    {this.props.auth.role === 'admin' && (
                        <Icon
                            size="large"
                            color="blue"
                            name={"delete"}
                            onClick={() => this.deleteFile()}
                        />
                    )}
                    {this.props.auth.role === 'distributor' && (
                        <Icon
                            size="large"
                        color={isLocked ? "grey" : "blue"}
                            name={"upload"}
                            onClick={() => this.uploadFile(row.row.fileName, row.row.id, row.row.remarks,row.row)}
                        disabled={isLocked || row.row.isChecked != true||!isWithinDateRange() || row.row.clusterStatus !== true}
                        />
                    )}
                </div>
            );
        },
    },
      {
        headerName: <p style={{color:'white'}}><strong>{"File Upload Status"}</strong></p>,
        field: "fileUploadStatus",
        headerClassName: 'super-app-theme--header',
        width: 200,
        style: { textAlign: "center", cursor: "pointer" },
        renderCell: (row) => (
          <AuditTableCell
            row={row.row}
            text={<strong>{row.row.fileUploadStatus != undefined ? row.row.fileUploadStatus : ''}</strong>}
          />
        ),
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"Failed Docs"}</strong></p>,
        field: "failedDocs",
        headerClassName: 'super-app-theme--header',
        style: { textAlign: "center", cursor: "pointer" },
        sortable: false,
        width: 150,
        filterable: false,
        renderCell: (row) => {
          return (
            <div style={{cursor:'pointer'}}>
               <Icon
              size="large"
              color="red"
              name="download"
              disabled={row.row.error_url && row.row.error_url != undefined ? false :true}
              onClick={() =>this.downloadFile(row.row.error_url)}
              
            />
            </div>
           
          );
        },
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"Supporting Attachments"}</strong></p>,
        field: "upload",
        headerClassName: 'super-app-theme--header',
        width: 200,
        style: { textAlign: "center", cursor: "pointer" },
        renderCell: (row) => (
          <div style={{cursor:'pointer'}}>
          {this.props.auth.role == 'distributor' && (
            <Icon
            size="large"
            color="blue"
            name= {"upload"}
            onClick={() => this.uploadSupportingFile(row.row.fileName,row.row.id,row.row.remarks)}
            disabled={row.row.fileUploadStatus == 'Success' ? false : true}
          />
         )}  
         </div>
        ),
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"Attachments Count"}</strong></p>,
        field: "count",
        headerClassName: 'super-app-theme--header',
        width: 170,
        style: { textAlign: "center", cursor: "pointer" },
        renderCell: (row) => {
          let overall = 0
          if(row.row.supporting_doc && row.row.supporting_doc!=undefined){
            row.row.supporting_doc.forEach((file)=>{
              overall+=1
            })
          }
          return (
            <AuditTableCell
            row={row.row}
            text={<strong>{overall}</strong>}
          />
           
          );
        },
      },
      {
        headerName: <p style={{color:'white'}}><strong>{"Remarks"}</strong></p>,
        field: "distRemarks",
        headerClassName: 'super-app-theme--header',
        width: 270,
        style: { textAlign: "center", cursor: "pointer" },
        renderCell: (row) => {
          const handleKeyDown = (e) => {
            if (e.key === ' ') {
              e.stopPropagation(); // Ensure no unwanted behavior happens
              // console.log("Spacebar pressed");
          }
        };
          return (
            <textarea
            placeholder="Enter remarks"
            value={row.row.disRemarks != undefined ? row.row.disRemarks : ''}  // Use the state to track remarks
            onChange={(e)=>this.handleRemarksChange(e,row)}  // Update the state on input change
            onKeyDown={handleKeyDown}
            rows={4}  // Number of visible rows (can adjust as needed)
            style={{ marginLeft: '10px', width: '100%',height:'50%'}}  // Allow resizing vertically
          />
           
          );
        },
      },
    ];

    return (
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          flexFlow: "column",
          height: "86vh",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        <Modal open={this.state.loading}>
          <Loader>Loading</Loader>
        </Modal>  
           <Dimmer active={this.state.loaderStatus}>
                <Loader size="massive">Processing.....</Loader>
              </Dimmer>      
        {this.state.mainView && (
          <div style={{ height: '100%', flex: 1 }} >
            <h1
              style={{
                marginLeft: 40,
                color: "#2185d0",
                display: "inline-block",
                fontSize: 25,
                fontFamily: "sans-serif",
                fontWeight: "bold",
              }}
            >
              P&G Disbursement
            </h1>
            <Divider />
            {this.state.pairUploadFlowActive && this.state.pairAwaitingSecond && (
              <div
                style={{
                  marginLeft: 40,
                  marginRight: 40,
                  marginBottom: 12,
                  padding: '10px 14px',
                  backgroundColor: '#fff4e5',
                  border: '1px solid #f2c27b',
                  borderRadius: 6,
                  color: '#7a4b00',
                  fontWeight: 600,
                }}
              >
                Pair upload pending: please complete both Seller Master and Store Master.
              </div>
            )}
            <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start',marginLeft:40}}>
            <div>
            <Dropdown placeholder='Select Month' search selection options={monthsList}
                                        onChange={this.onMonthChange}
                                        value={this.state.selectMonth}
                                        
                                    />
            </div>
            <div style={{marginLeft:'3%'}}>
            <Dropdown placeholder='Select Distributor' search selection options={distributorList}
                                        onChange={this.onDistributorChange}
                                        value={this.state.selectDistributor}
                                    />
            </div>
            <div style={{marginLeft:40}}>
            <Button
                color="blue"
                onClick={() => this.filterMaster()}
                disabled={this.state.selectDistributor && this.state.selectMonth != '' ? false : true}
              >
                <Icon name="filter" />  Filter
              </Button>
              </div>
              {this.props.auth.role === 'admin' && this.state.fileList.length > 0 && (
                <>
                  <div style={{marginLeft:20}}>
                    <label style={{marginRight: 10}}>
                      <input
                        type="checkbox"
                        checked={this.state.selectAllChecked}
                        onChange={(e) => this.handleSelectAll(e.target.checked)}
                      />
                      {' '}Select All
                    </label>
                  </div>
                  <div style={{marginLeft:20}}>
                    <Button
                      color="green"
                      onClick={this.downloadSelectedFilesHandler}
                      disabled={this.state.selectedFiles.length === 0}
                    >
                      <Icon name="download" /> Download Selected Files
                    </Button>
                  </div>
                </>
              )}
              {this.props.auth.role === 'admin' && this.state.selectMonth !== '' && (
                <div style={{marginLeft:20}}>
                  {this.state.bulkDownloadStatus && this.state.bulkDownloadStatus !== 'done' ? (
                    <Button color="teal" disabled loading>
                      {this.state.bulkDownloadStatus === 'pending' ? 'Queuing...' : 'Building zip...'}
                    </Button>
                  ) : (
                    <Button
                      color="teal"
                      onClick={this.downloadAllDistributorsZipHandler}
                    >
                      <Icon name="download" /> Download All Distributors
                    </Button>
                  )}
                </div>
              )}
            </div>
          
            <Box
      sx={{
        height: 300,
        width: '100%',
        '& .super-app-theme--header': {
          backgroundColor: 'rgba(33, 133, 208, 1)',
        },
      }}
    >

            <div style={{ marginTop: 30, marginLeft: 35, marginRight: 15, height: 450,width:'100%', overflowY: 'scroll'  }}>
              {this.props.auth.role == 'admin' && (
                 <DataGrid
                 rows={this.state.fileList}
                  getRowId={(row) => row._rowKey || `${row.id}-${row.fileName || ''}`}
                 columns={this.state.selectDistributor !== 'All Distributors' ? AdminColumnsDataGrid : otherCol}
               />
              )}
              {this.props.auth.role != 'admin' && (
                 <DataGrid
                 style={{overflow:'scroll'}}
                 rows={this.state.fileList}
                  getRowId={(row) => row._rowKey || `${row.id}-${row.fileName || ''}`}
                 columns={this.state.selectDistributor !== 'All Distributors' ? disbutorColGrid : otherCol}
               />
              )}
             
            </div>
            </Box>
            <Modal
                    open={this.state.modalOpen}
                    onClose={this.closeuploadoption}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h4>Upload Master data :</h4>
                                        <h5 style={{color:'red'}}>* Only Support .xlsx format</h5>
                                        <Input
                                            type="file"
                                            accept=".xlsx"
                                            onChange={this.fileupload}
                                            multiple
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.uploadTemplate}
                                title={'Upload'}
                                color={'green'}
                                iconColor={'white'}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>
                <Modal
                    open={this.state.supportingModalOpen}
                    onClose={this.closeuploadoption}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h4>Upload Supporting Attachments :</h4>
                                        <h5 style={{color:'red'}}>* Do Not Upload More Than 20 MB</h5>
                                        <Input
                                            type="file"
                                            // accept=".xlsx"
                                            onChange={this.supportingFileupload}
                                            multiple
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.uploadSupportingDocs}
                                title={'Upload'}
                                color={'green'}
                                iconColor={'white'}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>


                <Modal
                    open={this.state.mailModal}
                    onClose={this.closeuploadoption}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                      <label>Message</label>
                                      <textarea onChange={this.message}>

                                      </textarea>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.mailTrigger}
                                title={'Send Mail'}
                                color={'green'}
                                iconColor={'white'}
                                iconName={'email'}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>
                <Modal size={'small'} open={this.state.showDeleteConfirmModal} onClose={this.closeCandidateDeleteModal}> 
                            <Modal.Content>
                                <p>Are you sure you want to delete this file?</p>
                            </Modal.Content>
                            <Modal.Actions>
                                <Button negative onClick={this.closeCandidateDeleteModal}>No</Button>
                                <Button primary onClick={this.deleteTemplateMaster}>Yes</Button>
                            </Modal.Actions>
                        </Modal>

          </div>
        )}

      </div>
    );
  }
}

function AuditTableCell(props) {
  function onClick() {
    props.onClick(props.row);
  }
  return (
    <div style={props.style} onClick={onClick}>
      {props.text}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      fetchMasterData,
      filterMasterData,
      distributorFileUpload,
      distributorSupportingFileUpload,
      saveUploadedMasterfile,
      sendFeedbackMail,
      deleteFileFromDistributorSide,
      rollbackPairMasterUpload,
      userForceLogout,
      summaryRemarksUpload,
      downloadSelectedFiles,
      startBulkDownloadJob,
      pollBulkDownloadStatus
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MainView)
);
